<!-- =========================================================================================
    File Name: ChipCustomizeCloseClearChipIcon.vue
    Description: Change icon used for close and clear button
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <a-tag
      v-for="(chip, index) in items"
      :key="`${chip}-${index}`"
      @close.prevent="remove(chip)"
      closable
      class="rounded"
    >{{ chipValue(chip,chip.value) }}</a-tag>
  </div>
</template>

<script>
export default {
  props:{
    items: {
      type: Array,
      default: []
    },
    data: {
      type: Object,
      default: null
    },
  },
  methods: {
    async remove (item) {
      try{
        this.items.splice(this.items.indexOf(item), 1)
        this.$emit('deleteFilter',item)
      }catch (e) {
        throw new Error(e)
      }
    },
    chipValue(item,value){
      if (typeof value === "string") {
        return value
      }else{
        let arr = []
        if (item.field === 'practice_area')
          arr = this.data.practice_area
        else if (item.field === 'responsible' || item.field === 'origination' || item.field === 'matter__responsible' || item.field === 'assigned_user')
          arr = this.data.responsible
        else if (item.field === 'client' || item.field === 'matter__client')
          arr = this.data.contacts
        else if (item.field === 'group')
          arr = this.data.groups
        else if (item.field === 'matter')
          arr = this.data.matter
        const findItem = arr.find(select => select.id === value)
        if (findItem){
          if (item.field === 'practice_area' || item.field === 'group')
            return findItem.title
          else if (item.field === 'client' || item.field === 'matter__client')
            return findItem.person ? `${findItem.person.first_name} ${findItem.person.last_name}` : findItem.company.name
          else if (item.field === 'responsible' || item.field === 'origination' || item.field === 'matter__responsible' || item.field === 'assigned_user')
            return `${findItem.first_name} ${findItem.last_name}`
          if (item.field === 'matter')
            return findItem.title
        }
      }
    }
  },
}
</script>
